const backendBaseUrl = process.env.VUE_APP_BACKEND_URL || "";

export const config = {
  backendBaseUrl,
  apiBaseUrl:
    process.env.VUE_APP_API_BASE_URL || (backendBaseUrl ? backendBaseUrl + "/api" : "/api")
};

